import { RegisterSwimmerForm } from "../../components/RegisterSwimmerForm/RegisterSwimmerForm";
import { useRegisterSwimmersPage } from "./useRegisterSwimmersPage";
import { PageWrapper } from "../../../../shared/components/layout/PageWrapper";

/**
 * RegisterSwimmerPage
 * Page component for registering new swimmers.
 */
export const RegisterSwimmerPage: React.FC = () => {
  const {
    ageClassifications,
    handleCreateSwimmersBatch,
    handleNavigateToDashboard,
    isSubmitting,
    initialSwimmer,
    isLoadingSwimmer,
    isErrorSwimmer,
    swimmerTypes,
  } = useRegisterSwimmersPage();

  return (
    <PageWrapper
      isLoading={isLoadingSwimmer}
      loadingLabel="Cargando información del bañista..."
      isError={isErrorSwimmer}
      errorMessage="Error al cargar la información del bañista. Por favor, intente nuevamente."
      onBack={handleNavigateToDashboard}
      title="Registrar Bañistas"
    >
      <RegisterSwimmerForm
        ageClassifications={ageClassifications}
        swimmerTypes={swimmerTypes}
        onSubmit={handleCreateSwimmersBatch}
        isSubmitting={isSubmitting}
        initialSwimmer={initialSwimmer}
      />
    </PageWrapper>
  );
};
